// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogRepurchaseDeposit_dialogContact_1IUy5"};